import { axiosObj } from "./axios";
 
export const GetAllUserByOffsetAndCount = async (offset: string, count: string) => {
    const getAllUsers = axiosObj.get(`/parent/findAllTeacherParent?offset=${offset}&count=${count}`, {
        headers: {
            "Content-Type": "application/json",
        }
    });
    return (await getAllUsers).data
}
 
export const GetAllStudentByOffsetAndCount = async (offset: string, count: string) => {
    const getAllStudents = axiosObj.get(`/parent/findAllStudent?offset=${offset}&count=${count}`, {
        headers: {
            "Content-Type": "application/json",
        }
    });
    return (await getAllStudents).data
}
 
export const GetTotalPercentageData = async () => {
    const getPercentageData = axiosObj.get('/user/calculatePercentlastSevendaysData', {
        headers: {
            "Content-Type": "application/json",
        }
    });
 
    return (await getPercentageData).data
}
 
export const GetWeeklyPercentageData = async () => {
    const getWeeklyPercentageData = axiosObj.get('/user/lastSevendaysData', {
        headers: {
            "Content-Type": "application/json",
        }
    });
 
    return (await getWeeklyPercentageData).data
}
 
 
 
export const searchStudent = async (searchText: string, status: string, gradeId: string, offset: string, count: string, accessToken: string) => {

    const queryParams = new URLSearchParams();
 
    if (searchText) queryParams.append("name", searchText);
    if (status) queryParams.append("role", status);
    if (gradeId) queryParams.append("grade", gradeId)
    queryParams.append("offset", offset);
    queryParams.append("count", count);
 
    const url = `parent/searchStuentByFilter?${queryParams.toString()}`;
 
    try {
        const response = await axiosObj.get(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        });
 
        return response.data;
    } catch (error) {
        console.error("Error in searchTribe API:", error);
        throw error;
    }
};
 
export const searchUser = async (searchText: string, role: string, gradeId: string, offset: string, count: string, accessToken: string) => {

    const queryParams = new URLSearchParams();
 
    if (role) queryParams.append("role", role);
    if (gradeId) queryParams.append("grade", gradeId);
    if (searchText) queryParams.append("name", searchText);
 
    queryParams.append("offset", offset);
    queryParams.append("count", count);
 
    const url = `parent/searchTeacherParentByFilter?${queryParams.toString()}`;
 
    try {
        const response = await axiosObj.get(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        });
 
        return response.data;
    } catch (error) {
        console.error("Error in searchTribe API:", error);
        throw error;
    }
};
 
export const createGrade = async (data: { name: string }, accessToken: string) => {
    const createGradeRespone = axiosObj.post(`grade/createGrade`, data, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        }
    })
    return (await createGradeRespone).data
}
 
export const updateGrade = async (data: { id: number, name: string }, accessToken: string) => {
    const updateGradeRespone = axiosObj.put(`grade/updateGrade`, data, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        }
    })
    return (await updateGradeRespone).data
}
 
 
 
export const GetGradeById = async (gradeId: string, accessToken: string) => {
    const GetGradeByIdRespone = axiosObj.post(`grade/findGrade/{id}?id=${gradeId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        }
    })
    return (await GetGradeByIdRespone).data
}
 
export const GetAllGrade = async (accessToken: string) => {
    const GetAllGradeRespone = axiosObj.get(`grade/`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        }
    })
    return (await GetAllGradeRespone).data
}
 
export const checkGradeName = async (gradeId: string, gradeName: string, accessToken: string) => {
    // Build query parameters dynamically
    const queryParams = new URLSearchParams();
 
    if (gradeId) queryParams.append("id", gradeId);
    if (gradeName) queryParams.append("name", gradeName);
 
    const CheckGradeNameExistData = axiosObj.get(`grade/checkGrade/{name}/{id}?${queryParams.toString()}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        }
    });
    return (await CheckGradeNameExistData).data
}
 
export const searchGrade = async (gradeName: string, accessToken: string) => {
 
    const searchGradeResponse = axiosObj.get(`grade/SearchGrade/${gradeName}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        }
    });
    return (await searchGradeResponse).data
}
 
export const deleteGrade = async (gradeid: string, accessToken: string) => {
 
    const deleteGradeResponse = axiosObj.delete(`grade/${gradeid}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        }
    });
    return (await deleteGradeResponse).data
}